import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navbar from "react-bootstrap/Navbar";
import { useDispatch } from "react-redux";
import Nav from 'react-bootstrap/Nav';
import { useNavigate } from "react-router-dom";
import '../../Styles/tetdsc.css';
import { FiArrowRight, } from "react-icons/fi";
import { MdOutlineLocalPostOffice } from "react-icons/md";
import { FaExternalLinkAlt, FaHandPointRight, FaPhoneAlt } from "react-icons/fa";
import { HiOutlineArrowRight } from "react-icons/hi2";
import WavingCircleFlag from './CircleFlag.js';
import DotAnimation from "./DotAnimation";
import Notifications from "../Notifications.js";
import { config } from "../CommonUtilities/CommonUrl/CommonUrls";
import axios from "axios";
import moment from "moment";
import { ShowPDF } from "../CommonUtilities/CommonFunctions/CommonFunction";
import EmployeeLogin, { handleLogout } from "../../Auth/EmployeeLogin";
import DocumentsModal, { documentData } from "../DocumentsModal";
import { Modal, Table, Button } from "react-bootstrap";
import CandidateLogin from "../../Auth/CandidateLogin";
import Sweetalert, { InfoAlert2 } from "../CommonUtilities/CommonPopupAndAlerts/SweetAlerts.js";
import { ACADEMIC_YEAR, CONTEXT_NAME } from "../CommonUtilities/Validations/RegularExpAndVar.js";
import { FaFilePdf } from "react-icons/fa6";
import LatestUpdates from "./LatestUpdates.jsx";

export default function Home1() {
  let navigate = useNavigate();
  const [showData, setShowData] = React.useState(false);
  const [chshow, setchshow] = React.useState(false);

  const [dshow, setdShow] = useState(false);
  const handledClose = () => setdShow(false);
  const handledCShow = () => { setchshow(true) };

  const [showExamKeys, setExamKeys] = useState([]);
  const [examType, setExamType] = useState("");

  function renderExams() {
    setExamType("TET");
    let Url = config.url.DSC_Read_URL + "dsc-public/tet-paperwise-consolidated-key-path-details";
    axios.get(Url).then((res) => {
      if (res?.data?.status === true) {
        const keyData = res?.data?.data || [];
        const filteredKeyData = keyData.filter((val) => val?.consolidated_key_path);
        const formattedKeys = filteredKeyData?.map((val) => ({
          name: `${val?.post_name}-${val?.med_name}-${moment(val?.exam_dt).format("DD-MM-YYYY")} Shift ${val?.exam_shift}`,
          c_key: val?.consolidated_key_path,
          post: "Document",
          f_key: val?.final_key_path,
        }));
        setExamKeys(formattedKeys);
      } else {
        setExamKeys([]);
      }
    });
  }

  function dscKeys() {
    setExamType("DSC");
    let Url = config.url.DSC_DEPT_URL + "dsc-public/postwise-consolidated-key-path-details";
    axios.get(Url).then((res) => {
      if (res?.data?.status === true) {
        const keyData = res?.data?.data || [];
        const filteredKeyData = keyData.filter((val) => val?.consolidated_key_path);
        const formattedKeys = filteredKeyData?.map((val) => ({
          name: `${val?.post_name}-${moment(val?.exam_date).format("DD-MM-YYYY")} Shift ${val?.exam_session}`,
          c_key: val?.consolidated_key_path,
          post: "Document",
          f_key: val?.final_key_path,
        }));
        setExamKeys(formattedKeys);
      } else {
        setExamKeys([]);
      }
    });
  }
  //   useEffect(() => {
  //   if (showExamKeys?.length > 0) {
  //     setDocumentModal({
  //       show: true,
  //       title: "APDSC-2025 Final Key",
  //       data: showExamKeys,
  //     });
  //   }
  // }, [showExamKeys]);

  let dispatch = useDispatch();
  useEffect(() => {
    handleLogout(dispatch, navigate);
  }, []);

  const handleCShow = () => setchshow(true);
  const handleClose = () => {
    setShowData(false);
    setchshow(false);
  };

  const [documentModal, setDocumentModal] = React.useState({
    show: false,
    title: "",
    data: [],
  });

  const openDocumentModal = (title, dataKey) => {
    setDocumentModal({
      show: true,
      title: title,
      data: documentData[dataKey],
    });
  };

  const closeDocumentModal = () => {
    setDocumentModal({
      ...documentModal,
      show: false,
    });
  };

  const handleManualItemClick = (item) => {
    if (item.type === "document") {
      ShowPDF(item.url);
    } else if (item.type === "video") {
      window.open(item.url, "_blank");
    }
  };

  const [loading, setLoading] = useState(false);
  const [showGoPopup, setGopopup] = useState(false);
  const handleGoClose = () => setGopopup(false);
  const [showGoTetPopup, setGoTetPopup] = useState(false);
  const handleGoTetClose = () => setGoTetPopup(false);

  const [showGoTetPopup1, setGoTetPopup1] = useState(false);
  const handleGoTetClose1 = () => setGoTetPopup1(false);

  const [showGoSpTetPopup, setGoSpTetPopup] = useState(false);
  const handleGoSpTetClose = () => setGoSpTetPopup(false);

  let DSC_2025 = [
    {
      name: "Notification & Information Bulletin (School Education)", clickable: () => {
        handleGoClose();
        openDocumentModal("Notification & Information Bulletin (School Education)", "school")
      }
    },
    {
      name: "Notification & Information Bulletin (Residential Schools)", clickable: () => {
        handleGoClose(); openDocumentModal(
          "Notification & Information Bulletin (Residential Schools)",
          "society"
        )
      }
    },
    { name: "Subjects & Syllabus", clickable: () => { handleGoClose(); openDocumentModal("Subjects & Syllabus", "syllabus") } },
    { name: "MOCK TEST LINKS", clickable: () => { handleGoClose(); openDocumentModal("APDSC-2025 MOCK TEST LINKS", "MockTest") } },
    { name: "Final Key", clickable: () => { handleGoClose(); dscKeys(); } },
    { name: "Post Vacancies (School Education)", clickable: () => { navigate("/SEPostVacancies") } },
    { name: "Post Vacancies (Residential Education)", clickable: () => { navigate('/REPostVacancies') } },
    { name: "Press Note", url: 'pressNote', clickable: () => { handleGoClose(); openDocumentModal("Press Note", "pressNote") } },
    { name: "Government Orders (GOs)", url: 'gos', clickable: () => { handleGoClose(); openDocumentModal("Government Orders (GOs)", "gos") } },
    { name: "Frequently Asked Questions", url: 'faqs', clickable: () => { handleGoClose(); openDocumentModal("Frequently Asked Questions", "faqs") } },
    { name: "User Manual", url: 'manuals', clickable: () => { handleGoClose(); openDocumentModal("User Manual", "manuals") } },
    { name: "Schedule", url: 'schedule', clickable: () => { handleGoClose(); openDocumentModal("Schedule", "schedule") } },
    { name: "Mega DSC General Merit List-2025", clickable: () => { navigate('/MeritList1') } },
    { name: "Mega DSC Selection List-2025", clickable: () => { navigate('/SelectionList') } },
  ]
  const TET_2025 = [
    {
      name: "APTET Notification -2025", clickable: () => {
        handleGoTetClose();
        openDocumentModal("APTET Notification -2025", "tet_2025_notification")
      }
    },
    { name: "APTET G.O's", clickable: () => { handleGoClose(); openDocumentModal("APTET G.O's", "tet_go") } },
    { name: "APTET 2025 Syllabus", clickable: () => { handleGoClose(); openDocumentModal("APTET 2025 Syllabus", "tet_2025_syllabus") } },
    { name: "APTET Schedule -2025", clickable: () => { handleGoClose(); openDocumentModal("APTET Schedule -2025", "tet_2025_schedule") } },
    { name: "APTET information Bulletien-2025", clickable: () => { handleGoClose(); openDocumentModal("APTET information Bulletien-2025", "tet_2025_bullitin") } },
    { name: "APTET User Manual-2025", clickable: () => { handleGoClose(); openDocumentModal("APTET User Manual-2025", "tet_manuals") } },
    { name: "APTET FAQs & Instructions-2025", clickable: () => { handleGoClose(); openDocumentModal("APTET FAQs & Instructions-2025", "tet_2025_faq") } },
    //{ name: "APTET MOCK TEST LINKS-2025", clickable: () => { handleGoClose(); openDocumentModal("APTET MOCK TEST LINKS-2025", "TetMockTest") } },
    { name: "APTET Press Note -2025", clickable: () => { handleGoClose(); openDocumentModal("APTET Press Note -2025", "tet_2025_prss_note") } },
    //{ name: "APTET Final Answer Key", clickable: () => { handleGoClose(); renderExams(); } },
    {
      name: "Previous TET Result",
      clickable: () => { navigate("/TetResultsPrevious"); } // Direct navigation
    },
    // { name: "APTET Final Answer Keys -2025", clickable: () => { handleGoClose(); openDocumentModal("APTET Final Answer Keys -2025", "tet_press_note") } },
  ]

  const TET_2026 = [
    { name: "APTET-2026 Answer Key", clickable: () => { handleGoClose(); openDocumentModal("APTET-2026 Answer Keys", "tet_2026_keys") } },

    {
      name: "APTET August Notification -2026", clickable: () => {
        handleGoTetClose();
        openDocumentModal("APTET August Notification -2026", "tet_notification")
      }
    },
    { name: "APTET G.O's", clickable: () => { handleGoClose(); openDocumentModal("APTET G.O's", "tet_go") } },
    { name: "APTET 2026 Syllabus", clickable: () => { handleGoClose(); openDocumentModal("APTET 2026 Syllabus", "tet_syllabus") } },
    { name: "APTET Schedule -2026", clickable: () => { handleGoClose(); openDocumentModal("APTET Schedule -2026", "tet_schedule") } },
    { name: "APTET information Bulletien-2026", clickable: () => { handleGoClose(); openDocumentModal("APTET information Bulletien-2026", "tet_bullitin") } },
    { name: "APTET Guidelines-2026", clickable: () => { handleGoClose(); openDocumentModal("Guidelines", "guide_lines") } },
    { name: "APTET FAQs & Instructions-2026", clickable: () => { handleGoClose(); openDocumentModal("APTET FAQs & Instructions-2026", "tet_faq") } },
    { name: "APTET Press Note -2026", clickable: () => { handleGoClose(); openDocumentModal("APTET Press Note -2026", "tet_press_note") } },
  ]
  const SPTET_2026 = [
    { name: "Answer Key", clickable: () => { handleGoClose(); openDocumentModal("Special TET -2026 Answer Keys", "sptet_2026_keys") } },
    { name: "G.O's", clickable: () => { openDocumentModal("Special TET G.O's", "spl_tet_aug_go"); } },
    { name: "Notification", clickable: () => { openDocumentModal("Special TET Notification-2026", "spl_tet_notification") } },
    { name: "Schedule", clickable: () => { openDocumentModal("Special TET Schedule -2026", "spl_tet_schedule") } },
    { name: "Information Bulletien", clickable: () => { openDocumentModal("Special TET information Bulletien-2026", "spl_tet_bulletien") } },
    { name: "Press Note", clickable: () => { openDocumentModal("Special TET Press Note -2026", "spl_tet_press_note") } },
    { name: "Syllabus", clickable: () => { openDocumentModal("Syllabus", "tet_syllabus") } },
    { name: "FAQ's", clickable: () => { openDocumentModal("Special TET FAQs", "spl_tet_faqs") } },
  ]

  useEffect(() => {
    let data_key = showExamKeys;
    setExamKeys(data_key);
    if (showExamKeys?.length > 0) {
      let dynamicTitle = "Answer Keys";
      if (examType === "DSC") {
        dynamicTitle = "APDSC-2025 Answer Keys";
      } else if (examType === "TET") {
        dynamicTitle = "APTET-2025 Answer Keys";
      }
      setDocumentModal({
        show: true,
        title: dynamicTitle,
        data: showExamKeys,
      });
    }
  }, [showExamKeys]);
  const [showDeadlinePopup, setShowDeadlinePopup] = useState(true);

  return (
    <>
      <Modal show={showGoPopup} onHide={handleGoClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>DSC - 2025</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Details</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {DSC_2025 &&
                DSC_2025?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}.</td>
                    <td>{item?.name}</td>
                    <td>
                      <Button
                        variant="primary"
                        onClick={() => {
                          if (item?.clickable) {
                            item?.clickable(); // run custom function
                          } else {
                            navigate(item?.url); // or whatever navigation logic
                          }
                        }}
                      >
                        Click Here
                      </Button>
                    </td>

                  </tr>
                ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleGoClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showGoSpTetPopup} onHide={handleGoSpTetClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Special TET - 2026</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Details</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {SPTET_2026?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}.</td>
                  <td>{item?.name}</td>
                  <td>
                    <Button variant="primary"
                      onClick={() => {
                        handleGoSpTetClose();
                        item?.clickable();
                      }}
                    >
                      Click Here
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleGoTetClose1}> Close </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showGoTetPopup1} onHide={handleGoTetClose1} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>TET - 2026</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Details</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {TET_2026?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}.</td>
                  <td>{item?.name}</td>
                  <td>
                    <Button variant="primary"
                      onClick={() => {
                        handleGoTetClose1();
                        item?.clickable();
                      }}
                    >
                      Click Here
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleGoTetClose1}> Close </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showGoTetPopup} onHide={handleGoTetClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>TET - 2025</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Details</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {TET_2025?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}.</td>
                  <td>{item?.name}</td>
                  <td>
                    <Button
                      variant="primary"
                      onClick={() => {
                        handleGoTetClose();
                        item?.clickable();
                      }}
                    >
                      Click Here
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleGoTetClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showDeadlinePopup}
        onHide={() => setShowDeadlinePopup(false)}
        centered
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Body
          className="p-0 overflow-hidden position-relative"
          style={{
            background:
              "linear-gradient(135deg, #fff8f2 0%, #ffffff 50%, #f7f5ff 100%)",
            boxShadow: "0 14px 40px rgba(0,0,0,0.18)",
            // borderRadius: "18px",
          }}
        >
          {/* Close Button */}
          <button
            type="button"
            onClick={() => setShowDeadlinePopup(false)}
            style={{
              position: "absolute",
              top: "14px",
              right: "14px",
              width: "38px",
              height: "38px",
              borderRadius: "50%",
              border: "none",
              background: "#ffffff",
              color: "#444",
              fontSize: "22px",
              fontWeight: "700",
              zIndex: 10,
              cursor: "pointer",
              boxShadow: "0 3px 10px rgba(0,0,0,0.12)",
            }}
          >
            ×
          </button>

          {/* Header */}
          {/* Header */}
          {/* <div
            style={{
              background:
                "linear-gradient(135deg, #ffb347 0%, #ff8c42 100%)", padding: "18px 18px 16px",
              textAlign: "center",
            }}
          >
            <h2
              style={{
                color: "#0c0e0e",
                fontWeight: "800",
                fontSize: "24px",
                marginBottom: "2px",
                letterSpacing: "0.3px",
              }}
            >
              Important Notice
            </h2>

          
          </div> */}
          {/* Content */}
          {/* <div style={{ padding: "22px", }} >
            <div style={{
              background: "linear-gradient(135deg, #f2fbff 0%, #fbfeff 100%)", border: "2px solid #c9e8ff", borderRadius: "18px", padding: "18px",
              boxShadow: "0 6px 16px rgba(79,172,254,0.08)",
              position: "relative", overflow: "hidden",
            }}
            >
             
              <img src="/img/new2.gif" alt="extended" style={{ position: "absolute", top: "8px", right: "10px", height: "38px", opacity: 0.95, }} />

              <div className="d-flex align-items-start gap-3">
               
                <div style={{
                  minWidth: "34px", height: "34px", borderRadius: "16px",
                  background: "linear-gradient(135deg, #5dade2 0%, #48c6ef 100%)",
                  display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: "24px",
                  boxShadow: "0 5px 14px rgba(72,198,239,0.16)",
                }}
                >
                  📄
                </div>

                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px", flexWrap: "wrap", }} >
                    <h5 style={{ fontWeight: "800", color: "#004085", marginBottom: 0, fontSize: "18px", }} > Latest Updates </h5>
                  </div>

                  <p style={{ marginBottom: "10px", marginTop: "15px", }} >
                    <a href={process.env.PUBLIC_URL + "/DSC2026/DSC_2026 Suggestive Syllabus.pdf"} target="_blank"
                      rel="noopener noreferrer"
                      className="blink-color d-flex align-items-center gap-2"
                      style={{ cursor: "pointer", textDecoration: "none", fontWeight: "600", }} >
                      <FaFilePdf size={20} />
                      <span>Click here for DSC-2026 Suggestive Syllabus</span>
                      <FaExternalLinkAlt size={13} /> </a>

                    <a href={process.env.PUBLIC_URL + "/DSC2026/notifications/DSC-2026 General notification (1).pdf"} target="_blank"
                      rel="noopener noreferrer"
                      className="blink-color d-flex align-items-center gap-2"
                      style={{ cursor: "pointer", textDecoration: "none", fontWeight: "600", }} >
                      <FaFilePdf size={20} />
                      <span>Click here for General Notification</span>
                      <FaExternalLinkAlt size={13} /> </a>

                    <a href={process.env.PUBLIC_URL + "/DSC2026/notifications/DSC-2026 Socities Notification.pdf"} target="_blank"
                      rel="noopener noreferrer"
                      className="blink-color d-flex align-items-center gap-2"
                      style={{ cursor: "pointer", textDecoration: "none", fontWeight: "600", }} >
                      <FaFilePdf size={20} />
                      <span>Click here for Socities Notification</span>
                      <FaExternalLinkAlt size={13} /> </a>

                    <a href={process.env.PUBLIC_URL + "/DSC2026/notifications/DSC-2026 Special Education Notifcation.pdf"} target="_blank"
                      rel="noopener noreferrer"
                      className="blink-color d-flex align-items-center gap-2"
                      style={{ cursor: "pointer", textDecoration: "none", fontWeight: "600", }} >
                      <FaFilePdf size={20} />
                      <span>Click here for Special Education Notifcation</span>
                      <FaExternalLinkAlt size={13} /> </a>

                    <a href={process.env.PUBLIC_URL + "/DSC2026/Gos/2026SE_MS28_E.pdf"} target="_blank"
                      rel="noopener noreferrer"
                      className="blink-color d-flex align-items-center gap-2"
                      style={{ cursor: "pointer", textDecoration: "none", fontWeight: "600", }} >
                      <FaFilePdf size={20} />
                      <span>Click here for G.O.MS.No. 28</span>
                      <FaExternalLinkAlt size={13} /> </a>

                    <a href={process.env.PUBLIC_URL + "/DSC2026/Gos/2026SE_MS29_E.pdf"} target="_blank"
                      rel="noopener noreferrer"
                      className="blink-color d-flex align-items-center gap-2"
                      style={{ cursor: "pointer", textDecoration: "none", fontWeight: "600", }} >
                      <FaFilePdf size={20} />
                      <span>Click here for G.O.MS.No. 29</span>
                      <FaExternalLinkAlt size={13} /> </a>

                    <a href={process.env.PUBLIC_URL + "/DSC2026/Gos/2026SE_MS30_E.pdf"} target="_blank"
                      rel="noopener noreferrer"
                      className="blink-color d-flex align-items-center gap-2"
                      style={{ cursor: "pointer", textDecoration: "none", fontWeight: "600", }} >
                      <FaFilePdf size={20} />
                      <span>Click here for G.O.MS.No. 30</span>
                      <FaExternalLinkAlt size={13} /> </a>

                    <a href={process.env.PUBLIC_URL + "/DSC2026/DSC-2026 Press Note English.pdf"} target="_blank"
                      rel="noopener noreferrer"
                      className="blink-color d-flex align-items-center gap-2"
                      style={{ cursor: "pointer", textDecoration: "none", fontWeight: "600", }} >
                      <FaFilePdf size={20} />
                      <span>Click here for Press Note</span>
                      <FaExternalLinkAlt size={13} /> </a>

                    <a href={process.env.PUBLIC_URL + "/DSC2026/Special Education DSC - 2026.pdf"} target="_blank"
                      rel="noopener noreferrer"
                      className="blink-color d-flex align-items-center gap-2"
                      style={{ cursor: "pointer", textDecoration: "none", fontWeight: "600", }} >
                      <FaFilePdf size={20} />
                      <span>Click here for Special Education Syllabus</span>
                      <FaExternalLinkAlt size={13} /> </a>

                  </p>

                </div>
              </div>
            </div>


          </div> */}
          <LatestUpdates />
        </Modal.Body>
      </Modal>
      {config.url.status === 'dev' && <div className="dev-bg"></div>}
      <section id="tetdsc-banner-part">
        <div className="main-banner-part">
          <Navbar expand="sm" className="tetdsc-navbar">
            <Container fluid>
              <Navbar.Brand href="#" className="tetdsc-logoa">
                <div className="tetdsc-logo">
                  <img src="../img/ap-logo.webp" className="img-fluid" alt="ap-logo" />
                  <div className="tetdsc-logo-text">
                    <h5>Department of School Education</h5>
                    <h6>Government of Andhra Pradesh</h6>
                  </div>
                </div>
              </Navbar.Brand>
              <div className="right-tet">
                <Nav className="ms-auto" navbarScroll>
                  <div className="tetdsc-login-buttons">
                    <Nav.Link href="#home" className="">
                      <a href="#" onClick={(e) => {
                        e.preventDefault();
                        if (config.url.status === "dev") {
                          window.location.href = "http://dscofficers.dev.nidhi.apcfss.in/"; //NOSONAR
                        } else if (config.url.status === "prod") {
                          window.location.href = "https://dscofficers.apcfss.in/"; //NOSONAR
                        }
                      }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            if (config.url.status === "dev") {
                              window.location.href = "http://dscofficers.dev.nidhi.apcfss.in/"; //NOSONAR
                            } else if (config.url.status === "prod") {
                              window.location.href = "https://dscofficers.apcfss.in/"; //NOSONAR
                            }
                          }
                        }}>
                        <div className="tetdsc-department">
                          <p>Department<br></br>Login</p>
                          <img src="../img/department-icon.webp" className="img-fluid" alt="department-icon" />
                        </div>
                      </a>
                    </Nav.Link>
                    <Nav.Link href="#home" className="">
                      <a href="#" onClick={(e) => {
                        e.preventDefault(); handleCShow();
                      }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleCShow();
                          }
                        }}>
                        <div className="tetdsc-candidate">
                          <p>Candidate<br></br>Login</p>
                          <img src="../img/candidate-icon.webp" className="img-fluid" alt="department-icon" />
                        </div>
                      </a>
                    </Nav.Link>
                    <Nav.Link href="#home" className="">
                      <a href="#" onClick={(e) => {
                        e.preventDefault();
                        if (config.url.status === "dev") {
                          window.location.href = "http://sptet.dev.nidhi.apcfss.in/"; //NOSONAR
                        } else if (config.url.status === "prod") {
                          window.location.href = "https://sptet.apcfss.in/"; //NOSONAR
                        }
                      }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            if (config.url.status === "dev") {
                              window.location.href = "http://sptet.dev.nidhi.apcfss.in/"; //NOSONAR
                            } else if (config.url.status === "prod") {
                              window.location.href = "https://sptet.apcfss.in/"; //NOSONAR
                            }
                          }
                        }}>
                        <div className="tetdsc-spl-tet-candidate">
                          <p>Special TET For In Service Teachers<br></br>Login</p>
                          <img src="../img/candidate-icon.webp" className="img-fluid" alt="candid-icon" />
                        </div>
                      </a>
                    </Nav.Link>
                  </div>
                </Nav>

              </div>
            </Container>
          </Navbar>


          <div className="tetdsc-total-banner">
            <img src="../img/tetdsc-banner-left-shape.webp" className="img-fluid tetdsc-left-shape" alt="banner-left-shape" />
            <Row className="banner-row">
              <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="order-1 order-md-0">
                <div className="tetdsc-banner-left-img">
                  <img src="../img/tetdsc-banner-left2-img 2.webp" className="img-fluid img-above" alt="tetdsc-banner-left2-img 2" />
                  <img src="../img/tetdsc-cm-min 4.webp" className="img-fluid img-below" alt="tetdsc-cm-min 4" />
                  {/* <div className="ministers-text cm-position">
                    <h4>Sri Nara Chandrababu Naidu</h4>
                    <p>Hon'ble Chief Minister</p>
                  </div>
                  <div className="ministers-text minister-position">
                    <h4>Sri Nara Lokesh</h4>
                    <p>Hon'ble Human Resource Development Minister</p>
                  </div> */}
                </div>
              </Col>
              <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className="order-0 order-md-1">
                {/* <div className="tetdsc-banner-right-img text-center">
                  <img src="../img/tetdsc-banner-right-img.png" className="img-fluid" alt="banner-right-img" />
                </div> */}
                <div className="banner-animate">
                  {/* <div className="">
                    <DotAnimation />
                  </div> */}

                  <div className="apmap-all">
                    <img src="../img/dsc-ap-map.png" className="w-100 apmap" />
                  </div>
                  <div className="dots-all">
                    <DotAnimation />
                  </div>
                  {/* <div className="dots-all">
                    <img src="../img/dots-bg.png" className="dots-bg" />
                  </div> */}
                  <div className="trees-all">
                    <img src="../img/tree-small.png" className="tree-small" />
                    <img src="../img/tree-big.png" className="tree-big" />
                  </div>
                  <div className="king-all">
                    <img src="../img/king.png" className="king-stand" />
                  </div>
                  <div className='wave-flag'>
                    <WavingCircleFlag />
                  </div>
                  <div className="cloude-all">
                    <img src="../img/cloude-small.png" className="cloude-small" />
                    <img src="../img/cloude-big.png" className="cloude-big" />
                  </div>
                  <div className="dream-all swing">
                    <img src="../img/dream-captch.png" className="dream-captch" />
                  </div>
                  <div className="text-all">
                    <h2>TET</h2>
                  </div>
                  <div className="door-all">
                    <div class="d-flx flx-column justify-content-centr  door"><h3>DSC</h3></div>
                    <img src="../img/door-bottom.png" className="door-bottom" />
                  </div>
                  <div className="humans-all">
                    <img src="../img/Humans.png" className="humans" />
                  </div>
                  <div class="ocean d-none">
                    <div class="wave"></div>
                    <div class="wave2"></div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>
      <section id="application-part">
        <Container>
          <Row>
            <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
              <div className="application-box1">
                <h6>Special TET For In Service Teachers Application</h6>
                <div className="application-text">
                  <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                      <div className="content-application1">
                        <div>
                          <p>Start Date</p>
                          <h5>25-08-2026</h5>
                        </div>
                      </div>
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                      <div className="content-application2">
                        <div>
                          <p>End Date</p>
                          <h5>24-09-2026</h5>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6} className="mt-4 mt-lg-0">
              <div className="application-box2"
                onClick={() => {
                  // Sweetalert("Coming Soon....","info")
                  navigate('/ForgotPassword')
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    // Sweetalert("Coming Soon....","info")
                    navigate('/ForgotPassword');
                  }
                }}
              >
                <h6>Forgot Password?</h6>
                <img src="../img/forgot-password.webp" className="img-fluid" alt="forgot-img" />
                <HiOutlineArrowRight className="tet-arrow-icon" />
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6} className="mt-4 mt-lg-0">
              <div className="application-box3"
                onClick={(e) => {
                  Sweetalert("Coming Soon....", "info")
                  // navigate('/RegistrationForm')
                  e.preventDefault();
                  //handleCShow();
                }}
                onKeyDown={(e) => {
                  Sweetalert("Coming Soon....", "info")
                  // navigate('/RegistrationForm')
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    //handleCShow();
                  }
                }}
              >
                <h6>Register Here</h6>
                <img src="../img/register 1.webp" className="img-fluid" alt="register-img" />
                <HiOutlineArrowRight className="tet-arrow-icon" />
                {/* <h6> */}
                {/* <img
        src="/img/new2.gif"
        style={{ height: "30px" }}
        className="img-fluid"
        alt="new"
      /> */}
                {/* TET RESULTS</h6> */}

              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section id="columns">
        <Container>
          <Row>
            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12} className="">
              <div className="teachers-all me-lg-5 ms-lg-3">
                <h1>AP Teacher Eligibility
                  Test <span>to</span> District
                  Selection Committee</h1>
                <p>The Andhra Pradesh Teacher Eligibility Test (APTET) is a state-level examination conducted by the Department of School Education, Government of Andhra Pradesh. It is designed to assess the eligibility of candidates aspiring to become teachers for Classes I to VIII in government, Zilla Parishad, Mandal Parishad, municipal, and private aided schools within Andhra Pradesh.</p>
              </div>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={12} className="mt-4 mt-xl-0">
              <Notifications handledCShow={handledCShow} />
              {/* <div className="notifications-all d-none">
                <h2>Notifications</h2>
                <ul>
                  <li><a href="#">AP TET July-2025 Examination Schedule</a></li>
                  <li><a href="#">AP TET Notification</a></li>
                  <li><a href="#">AP TET Information Bulletin</a></li>
                </ul>
                <div className="d-flex justify-content-end">
                  <button><FiArrowUp className="notific-arrow" /></button>
                  <button><FiArrowDown className="notific-arrow" /></button>
                </div>
              </div> */}
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="">
              <div className="options-all options-all1">
                <Row>

                  {/* <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault(); navigate("/KnowUserId");
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          navigate("/KnowUserId");
                        }
                      }}
                    >
                      <span>Know UserId ?</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col> */}

                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        // Sweetalert("Coming Soon...", "info")
                        e.preventDefault();
                        openDocumentModal(
                          "DSC 2026 G.O's",
                          "dsc_2026_gos"
                        )
                      }
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          //Sweetalert("Coming Soon...", "info")
                          openDocumentModal(
                            "DSC 2026 G.O's",
                            "dsc_2026_gos"
                          );
                        }
                      }}
                    >
                      <span>GO's</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>

                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        //Sweetalert("Coming Soon...", "info")
                        e.preventDefault();
                        openDocumentModal(
                          "DSC-2026 Notification",
                          "dsc_2026_notifications"
                        )
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          //Sweetalert("Coming Soon...", "info")
                          openDocumentModal(
                            "DSC-2026 Notification",
                            "dsc_2026_notifications"
                          );
                        }
                      }}
                    >
                      <span>Notification</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        Sweetalert("Coming Soon...", "info")
                        // openDocumentModal(
                        //   "Special TET Schedule -2026",
                        //   "spl_tet_schedule"
                        // )
                      }}
                      onKeyDown={(e) => {
                        Sweetalert("Coming Soon...", "info")
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          // openDocumentModal( "Special TET Schedule -2026", "spl_tet_schedule" );
                        }
                      }}
                    >
                      <span>Schedule</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        Sweetalert("Coming Soon...", "info")
                        e.preventDefault();
                        // openDocumentModal(
                        //  "Special TET information Bulletien-2026",
                        //   "spl_tet_bulletien"
                        // );
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          Sweetalert("Coming Soon...", "info")
                          // openDocumentModal(
                          //   "Special TET information Bulletien-2026",
                          //   "spl_tet_bulletien"
                          // );
                        }
                      }}
                    >
                      <span>Information Bulletien
                        {/* TET, FEB 2024 Result */}
                      </span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        //Sweetalert("Coming Soon...", "info")
                        openDocumentModal(
                          "DSC-2026 Press Note",
                          "dsc_2026_press_note"
                        )
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          //  Sweetalert("Coming Soon...", "info")
                          openDocumentModal(
                            "DSC-2026 Press Note",
                            "dsc_2026_press_note"
                          );
                        }
                      }}
                    >
                      <span>Press Note</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>

                  {/* <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                         Sweetalert("Coming Soon...","info")
                        e.preventDefault();
                        // navigate("/TetResultsPrevious");
                      }}
                      onKeyDown={(e) => {
                        // if (e.key === "Enter" || e.key === " ") {
                        //   e.preventDefault();
                        //   navigate("/TetResultsPrevious");
                        // }
                      }}
                    >
                      <span>Previous TET Result </span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col> */}
                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        //Sweetalert("Coming Soon...", "info")
                        e.preventDefault();
                        openDocumentModal("DSC 2026 Syllabus", "dsc_2026_syllabus")
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          //Sweetalert("Coming Soon...", "info")
                          openDocumentModal("DSC 2026 Syllabus", "dsc_2026_syllabus");
                        }
                      }}
                    >
                      <span>Syllabus</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  {/* <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        //  Sweetalert("Coming Soon...","info")
                        e.preventDefault();
                        openDocumentModal("Guidelines", "guide_lines")
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          openDocumentModal("Guidelines", "guide_lines")
                        }
                      }}
                    >
                      <span>Guidelines</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col> */}
                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        //  Sweetalert("Coming Soon...","info")
                        e.preventDefault();
                        // openDocumentModal("FAQs & Instructions", "tet_faq")
                        openDocumentModal("Special TET FAQs", "spl_tet_faqs")
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          //  Sweetalert("Coming Soon...","info")
                          //openDocumentModal("FAQs & Instructions", "tet_faq")
                          openDocumentModal("Special TET FAQs", "spl_tet_faqs")
                        }
                      }}
                    >
                      <span>FAQs </span>
                      {/* & Instructions  */}
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>

                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={() =>
                        //  Sweetalert("Coming Soon...","info")
                        openDocumentModal("TET MOCK TEST LINKS", "TetMockTest")
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          //  Sweetalert("Coming Soon...","info")
                          openDocumentModal("TET MOCK TEST LINKS", "TetMockTest");
                        }
                      }} >  <span>MockTests</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>

                  {/* <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
  <a href="#"
    onClick={(e) => {
      e.preventDefault();
       Sweetalert("Coming Soon...","info")
      // handleGoClose?.();      
      // renderExams(); 
      }}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        // handleGoClose?.();
        // renderExams();
      }
    }}
  > <span>Exam-Answer Keys</span>
    <FiArrowRight className="option-icon" />
  </a>
</Col> */}
                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setGopopup(true)
                        // openDocumentModal("DSC-2025", "DSC")
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault(); setGopopup(true);
                          // openDocumentModal("DSC-2025", "DSC")
                        }
                      }}
                    >
                      <span>DSC-2025</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setGoTetPopup(true)

                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault(); setGoTetPopup(true);

                        }
                      }}
                    >
                      <span>TET-2025</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setGoTetPopup1(true)
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setGoTetPopup1(true);
                        }
                      }}
                    >
                      <span>TET-August-2026</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={4} sm={6} xs={6} className="mb-4">
                    <a href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setGoSpTetPopup(true)
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setGoSpTetPopup(true);
                        }
                      }}
                    >
                      <span>Special TET-2026</span>
                      <FiArrowRight className="option-icon" />
                    </a>
                  </Col>
                </Row> </div>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="">
              <div className="helps-all helps-all1">
                <h2>For any domain related issues</h2>
                <h5><MdOutlineLocalPostOffice className="helps-post" />grievances.tet@apschooledu.in</h5>
                <Row>
                  <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6} className="mb-3 helps-number">
                    <div className="d-flex justify-content-center">
                      <span><FaPhoneAlt className="helps-phone" />8121947387</span>
                    </div>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6} className="mb-3">
                    <div className="d-flex justify-content-center">
                      <span><FaPhoneAlt className="helps-phone" />8125046997</span>
                    </div>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6} className="mb-3">
                    <div className="d-flex justify-content-center">
                      <span><FaPhoneAlt className="helps-phone" />7995649286</span>
                    </div>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6} className="mb-3">
                    <div className="d-flex justify-content-center">
                      <span><FaPhoneAlt className="helps-phone" />7995789286</span>
                    </div>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6} className="mb-3">
                    <div className="d-flex justify-content-center">
                      <span><FaPhoneAlt className="helps-phone" />6281704160</span>
                    </div>
                  </Col>
                  <Col xxl={2} xl={2} lg={2} md={6} sm={6} xs={6} className="mb-3">
                    <div className="d-flex justify-content-center">
                      <span><FaPhoneAlt className="helps-phone" />7386282388
                        {/* 9398810958 */}
                      </span>
                    </div>
                  </Col>
                  {/* <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} className="mb-3">
                                <div className="d-flex justify-content-center">
                                  <span><FaPhoneAlt className="helps-phone" />8125046997</span>
                                </div>
                              </Col>
                              <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} className="mb-3">
                                <div className="d-flex justify-content-center">
                                  <span><FaPhoneAlt className="helps-phone" />6281704160</span>
                                </div>
                              </Col>
                              <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} className="mb-3">
                                <div className="d-flex justify-content-center">
                                  <span><FaPhoneAlt className="helps-phone" />9398822554</span>
                                </div>
                              </Col>
                              <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} className="mb-3">
                                <div className="d-flex justify-content-center">
                                  <span><FaPhoneAlt className="helps-phone" />9398822618</span>
                                </div>
                              </Col> */}
                </Row>
                <p>(Call Time : 10.00 AM to 1.00 PM & 1.30 PM to 05.30 PM on all working days)</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <div className="footer d-flex justify-content-center">
        <p>Designed and developed by</p>
        <a href="apcfss.in">
          <img
            src="../img/apcfss-logo.png"
            className="d-inline-block align-top"
            alt="Tet Dsc"
          /></a>
      </div>
      <Modal show={showData} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Department Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EmployeeLogin />
        </Modal.Body>
      </Modal>
      {/* <Modal show={chshow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Candidate Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CandidateLogin />
        </Modal.Body>
      </Modal> */}
      <Modal show={chshow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Candidate Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CandidateLogin />
          {/* <h5 className="text-primary">
      Candidate Login will be enabled soon...!
    </h5> */}
        </Modal.Body>
      </Modal>


      {/* <DocumentsModal
        show={documentModal.show}
        handleClose={closeDocumentModal}
        title={documentModal.title}
        data={
          documentModal.data === "APTET-2025 Answer Key"
            ? showExamKeys
            : documentModal.data
        }
      
        onItemClick={
          documentModal.title === "User Manual" ? handleManualItemClick : null
        }
      /> */}
      <DocumentsModal
        show={documentModal.show}
        handleClose={closeDocumentModal}
        handleCShow={handleCShow}
        title={documentModal.title}
        data={documentModal.data}
        onItemClick={
          documentModal.title === "User Manual"
            ? handleManualItemClick
            : null
        }
      />


    </>
  );
}
